import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import { LocalizationService } from '../services/localization/localization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private afAuth: AngularFireAuth,
    private localizationService: LocalizationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.afAuth.authState.pipe(
      map(user => !!user),
      tap(loggedIn => loggedIn || this.localizationService.goToLogin(state.url))
    );
  }
}
